import React from "react";
import { Grid } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SettingsCard from "./SettingsCard";

const HeaderContentSection = ({
  headerEmail,
  setHeaderEmail,
  headerPhone,
  setHeaderPhone,
  autoSaveField,
}) => {
  return (
    <SettingsCard
      title="Header Content"
      subtitle="Configure header contact information"
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12} md={6}>
          <FormField
            value={headerEmail}
            onChange={(e) => setHeaderEmail(e.target.value)}
            onBlur={(e) => autoSaveField && autoSaveField("email", e.target.value)}
            placeholder="email@smartdirectory.ai"
            label="Email"
            name="email"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormField
            value={headerPhone}
            onChange={(e) => setHeaderPhone(e.target.value)}
            onBlur={(e) => autoSaveField && autoSaveField("phone", e.target.value)}
            placeholder="(555) 123-4567"
            label="Phone"
            name="phone"
          />
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default HeaderContentSection;
